import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProfileSideMenu from "./profileSideMenu";
import { isProfileSideMenuHidden } from "../utils/profileMenuNavigation";

export const useShowProfileSideMenu = () => {
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(() => !isProfileSideMenuHidden());

  useEffect(() => {
    setShowMenu(!isProfileSideMenuHidden());
  }, [location.pathname]);

  return showMenu;
};

const ProfilePageLayout = ({ children, contentClassName = "profile-page-content1" }) => {
  const showProfileSideMenu = useShowProfileSideMenu();

  return (
    <div
      className={`profile-page-wrap ${showProfileSideMenu ? "" : "standalone"} d-flex flex-wrap`}
    >
      {showProfileSideMenu && <ProfileSideMenu />}
      <div className={contentClassName}>{children}</div>
    </div>
  );
};

export default ProfilePageLayout;
